// import React, { useEffect, useState } from 'react'
// import "./CheckoutContainer.css"
// import { useSelector } from 'react-redux';
// import AddressBox from '../AddressBox/AddressBox';
// import axios from 'axios';
// import { Link } from 'react-router-dom';
// function CheckoutContainer({ sendDataToParent,sendPhoneToParent }) {
//     const userinfo = useSelector((state) => state);
//     const [address, setAddress] = useState([])
//     const [phone, setPhone] = useState(userinfo.auth.userArray?.phone)
//     const [notes, setNotes] = useState()
//     console.log(userinfo.auth.userArray);
    
//     useEffect(() => {
//         const getAllApis = async () => {
//             await axios
//                 .get(`https://nanosoft.technology/smile/api/client/addresses`,

//                     {
//                         headers: {
//                             Authorization: `Bearer ${userinfo?.auth?.access_token}`
//                         }
//                     })

//                 .then(async (res) => {
//                     console.log(res.data.data);
                    
//                     const filteredArray = res.data.data.filter(item => item.default==0);

//                     setAddress(filteredArray)

//                 })
//                 .catch((error) => {
//                     // setShow(true)

//                     setAddress(error.response.data);


//                 });
//         }
//         getAllApis()
//     }, [])

//     return (
//         <div className='checkout_container'>
//             <div className='mb-4'>
//                 <h3>Contact phone number</h3>
//                 <input
//                     value={phone}
//                     className='phone_number'
//                     onChange={(e) => {
//                         sendPhoneToParent(e.target.value)
//                         setPhone(e.target.value)}}
//                 />

//             </div>
//             <div className='mb-4'>
//                 <h3>Notes</h3>
//                 <textarea
//                     value={notes}
//                                         className='phone_number'

//                     onChange={(e) => {
//                         setNotes(e.target.value)}}
//                 >
// </textarea>
//             </div>
//             <div className='mb-4'>
//                 <div className='d-flex justify-content-between'>
//                     <h3>Address</h3>
//                     <Link to="/user/addressbook">
//                         Edite
//                     </Link>
//                 </div>
//                 <AddressBox
//                     item={address[0]}
//                 />
//             </div>

//             <div className='mb-4'>
//                 <h3>Payment</h3>
//                 <div className='payment_method'>
//                     <input type='radio' id="CASH" name="method" value="CASH"
//                         onChange={(e) => {

//                             sendDataToParent(e.target.value)

//                         }}
//                     />
//                     <label className='mx-2 w-75' htmlFor={'CASH'}>Cash</label>



//                 </div>

//                 {/* <div className='payment_method'>
//                     <input type='radio' id="CARD" name="method" value="CARD"
//                         onChange={(e) => {
//                             sendDataToParent(e.target.value);

//                         }}
//                     />
//                     <label className='mx-2 w-75' htmlFor={'CARD'}>Visa Card</label>



//                 </div>
//                 <div className='payment_method'>
//                     <input type='radio' id="WALLET" name="method" value="WALLET"
//                         onChange={(e) => {
//                             sendDataToParent(e.target.value);

//                         }}
//                     />
//                     <label className='mx-2 w-75' htmlFor={'WALLET'}>wallet</label>



//                 </div> */}
//             </div>
//         </div>
//     )
// }

// export default CheckoutContainer
import React, { useEffect, useState } from 'react';
import "./CheckoutContainer.css";
import { useSelector } from 'react-redux';
import AddressBox from '../AddressBox/AddressBox';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Col, Container, Row } from 'react-bootstrap';

function CheckoutContainer({ sendDataToParent }) {
  const userinfo = useSelector((state) => state);
  const [address, setAddress] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [phone, setPhone] = useState(userinfo.auth.userArray?.phone || '');
  const [notes, setNotes] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('cash'); // default cash
  const { currentLocal } = useSelector((state) => state.currentLocal);

  useEffect(() => {
    const getAllApis = async () => {
      try {
        const res = await axios.get(
          `https://nanosoft.technology/smile/api/client/addresses`,
          {
            headers: {
              Authorization: `Bearer ${userinfo?.auth?.access_token}`,
            },
          }
        );
        const filteredArray = res.data.data.filter((item) => item.default == 1);
        setAddress(filteredArray);
        setSelectedAddress(filteredArray[0]); // set first as default
      } catch (error) {
        console.log(error.response?.data);
      }
    };

    getAllApis();
  }, []);

  // ✅ Send data to parent every time a relevant field changes
  useEffect(() => {
    if (selectedAddress) {
      sendDataToParent({
        payment_method: paymentMethod.toLowerCase(), // 'cash'
        address_id: selectedAddress?.id,
        coupon: "", // you can later add coupon field
        note: notes,
        phone: phone,
      });
    }
  }, [paymentMethod, phone, notes, selectedAddress]);

  return (
    <div className="checkout_container">
  
    
<Container>
  <Row>
        <Col md={12}>
      <div className="mb-4">
        <h3>{currentLocal.home.Notes}</h3>
        <textarea
          value={notes}
          className="phone_number"
          onChange={(e) => setNotes(e.target.value)}
        />
      </div>
    </Col>
    <Col md={12}>
              <div className="mb-4">
        <h3>{currentLocal.home.phone}</h3>
        <input
          value={phone}
          className="phone_number"
          onChange={(e) => setPhone(e.target.value)}
        />
      </div>

    </Col>

  </Row>
</Container>

      <div className="mb-4">
        <div className="d-flex justify-content-between">
          <h3>{currentLocal.home.Address}</h3>
          <Link to="/user/addressbook">{currentLocal.home.edit}</Link>
        </div>

        {selectedAddress && (
          <AddressBox item={selectedAddress} />
        )}
      </div>

      <div className="mb-4">
        <h3>
{currentLocal.home.Payment}
        </h3>
        <div className="payment_method">
          <input
            type="radio"
            id="CASH"
            name="method"
            value="cash"
            checked={paymentMethod === "cash"}
            onChange={(e) => setPaymentMethod(e.target.value)}
          />
          <label className="mx-2 w-75" htmlFor="CASH">
            {currentLocal.home.Cash}
          </label>
        </div>

        {/* <div className="payment_method">
          <input
            type="radio"
            id="VISA"
            name="method"
            value="visa"
            checked={paymentMethod === "visa"}
            onChange={(e) => setPaymentMethod(e.target.value)}
          />
          <label className="mx-2 w-75" htmlFor="VISA">
            Visa
          </label>
        </div> */}

        {/* <div className="payment_method">
          <input
            type="radio"
            id="ONLINE"
            name="method"
            value="online"
            checked={paymentMethod === "online"}
            onChange={(e) => setPaymentMethod(e.target.value)}
          />
          <label className="mx-2 w-75" htmlFor="ONLINE">
            Online
          </label>
        </div> */}
      </div>
    </div>
  );
}

export default CheckoutContainer;
